import React from 'react';
import { Input, Section } from '../Shared';
import { CITING_SECTION_TITLE } from './constants';

/** Advetisement citing section id and testId */
export var SECTION_ID = 'advertisement-citing-section';
export var SECTION_TEST_ID = 'advertisement-citing-section-test-id';
export var ADVERTISEMENT_TITLE_INPUT_TEST_ID = 'advertisement-title-input-test-id';
export var ADVERTISEMENT_NAME_INPUT_TEST_ID = 'advertisement-name-input-test-id';
export var AdvertisementCiting = function AdvertisementCiting() {
  return /*#__PURE__*/React.createElement(Section, {
    sectionId: SECTION_ID,
    title: CITING_SECTION_TITLE,
    ariaLabelledby: "".concat(SECTION_ID, "-label"),
    dataTestId: SECTION_TEST_ID
  }, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "advertisement.corp",
    labelText: "Advertiser name",
    "data-test": ADVERTISEMENT_NAME_INPUT_TEST_ID
  }), /*#__PURE__*/React.createElement(Input, {
    type: "text",
    name: "advertisement.title",
    labelText: "Advertisement title",
    "data-test": ADVERTISEMENT_TITLE_INPUT_TEST_ID
  }));
};